<template>
    <app-content class="h-panel">
      <!-- 标题栏：完全对齐账套管理风格 -->
      <div class="h-panel-bar"><span class="h-panel-title">税务信息设置</span></div>
      
      <!-- 按钮区域：对齐账套管理的布局样式 -->
      <div class="margin-top margin-left">
        <Button @click="submit" color="primary" icon="fa fa-save">保存</Button>&nbsp;&nbsp;
        <Button @click="reset" icon="fa fa-refresh">重置</Button>
      </div>
  
      <!-- 表单内容区域 -->
      <div class="h-panel-body padding">
        <Form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="120"
          class="w-[600px]"
        >
          <FormItem label="公司名称" prop="companyName">
            <Input v-model="form.companyName" placeholder="请输入公司名称" />
          </FormItem>
  
          <FormItem label="社会信用代码" prop="creditCode">
            <Input v-model="form.creditCode" placeholder="请输入统一社会信用代码" />
          </FormItem>
  
          <FormItem label="报税地区" prop="province">
            <Select
              v-model="form.province"
              placeholder="请选择报税省份"
              :datas="provinceList"
              @change="provinceChange"
            />
          </FormItem>
  
          <FormItem label="身份类型" prop="identityType">
            <Select
              v-model="form.identityType"
              placeholder="请选择身份类型"
              :datas="identityList"
            />
          </FormItem>
  
          <FormItem label="税务局实名账号" prop="taxAccount">
            <Input v-model="form.taxAccount" placeholder="请输入电子税务局账号" />
          </FormItem>
  
          <FormItem label="税务局密码" prop="taxPassword">
            <Input
              v-model="form.taxPassword"
              type="password"
              placeholder="请输入电子税务局密码"
              show-password
            />
          </FormItem>
  
          <FormItem label="备注" prop="remark">
            <Input
              v-model="form.remark"
              type="textarea"
              :row="3"
              placeholder="请输入备注信息"
            />
          </FormItem>
        </Form>
      </div>
    </app-content>
  </template>
  
  <script>
  export default {
    name: "TaxInformation",
    data() {
      return {
        form: {
          id: null,
          companyName: "",
          creditCode: "",
          province: "",
          provinceName: "",
          identityType: "",
          taxAccount: "",
          taxPassword: "",
          remark: ""
        },
        rules: {
          companyName: [{ required: true, message: "请输入报税公司名称" }],
          creditCode: [{ required: true, message: "请输入社会信用代码" }],
          province: [{ required: true, message: "请选择报税地区" }],
          identityType: [{ required: true, message: "请选择身份类型" }],
          taxAccount: [{ required: true, message: "请输入税务局账号（居民身份证号/手机号/用户名）" }],
          taxPassword: [{ required: true, message: "请输入税务局密码" }],
        },
        provinceList: [
          { key: "110000", title: "北京市" },
          { key: "120000", title: "天津市" },
          { key: "130000", title: "河北省" },
          { key: "140000", title: "山西省" },
          { key: "150000", title: "内蒙古自治区" },
          { key: "210000", title: "辽宁省" },
          { key: "220000", title: "吉林省" },
          { key: "230000", title: "黑龙江省" },
          { key: "310000", title: "上海市" },
          { key: "320000", title: "江苏省" },
          { key: "330000", title: "浙江省" },
          { key: "340000", title: "安徽省" },
          { key: "350000", title: "福建省" },
          { key: "360000", title: "江西省" },
          { key: "370000", title: "山东省" },
          { key: "410000", title: "河南省" },
          { key: "420000", title: "湖北省" },
          { key: "430000", title: "湖南省" },
          { key: "440000", title: "广东省" },
          { key: "450000", title: "广西壮族自治区" },
          { key: "460000", title: "海南省" },
          { key: "500000", title: "重庆市" },
          { key: "510000", title: "四川省" },
          { key: "520000", title: "贵州省" },
          { key: "530000", title: "云南省" },
          { key: "540000", title: "西藏自治区" },
          { key: "610000", title: "陕西省" },
          { key: "620000", title: "甘肃省" },
          { key: "630000", title: "青海省" },
          { key: "640000", title: "宁夏回族自治区" },
          { key: "650000", title: "新疆维吾尔自治区" },
// 计划单列市 👇
        { key: "210200", title: "大连市" },
        { key: "330200", title: "宁波市" },
        { key: "350200", title: "厦门市" },
        { key: "370200", title: "青岛市" },
        { key: "440300", title: "深圳市" },	
        ],
        identityList: [
          { key: "FINANCE", title: "财务负责人" },
          { key: "TAX", title: "办税员" },
        ],
      };
    },
    mounted() {
      this.loadData();
    },
    methods: {
      async loadData() {
        const res = await this.$api.setting.taxInfo.get();
        if (res && res.success && res.data) {
          this.form = res.data;
        }
      },
      provinceChange(val) {
        let curr = this.provinceList.find(x => x.key == val);
        if (curr) {
          this.form.provinceName = curr.title;
        }
      },
      async submit() {
        const valid = await this.$refs.formRef.valid();
        if (!valid) return;
        this.provinceChange(this.form.province);
  
        const res = await this.$api.setting.taxInfo.save(this.form);
        if (res.success) {
          this.$Message.success('保存成功！');
        }
      },
      reset() {
        this.form = {
          id: null,
          companyName: "",
          creditCode: "",
          province: "",
          provinceName: "",
          identityType: "",
          taxAccount: "",
          taxPassword: "",
          remark: ""
        };
        this.$refs.formRef.clearError();
      },
    },
  };
  </script>
  
  <style scoped>

  div.h-panel-body {
    padding-top: 16px;
  }
  
</style>
  